// The design lock for the introit (static/introit.html, served at
// /introit): the game playing itself, the first thing a new visitor sees and
// a wordless guide. Each scene plays one rite's stored proof on the real
// table, under the riddle of the law it shows; then the lattice fills (each
// tablet folds when it is whole), the Ternion folds the three tablets under
// the first rite's riddle, the Monad rises, and the title holds. An introit
// is the chant sung as a rite enters the temple.

import type { RiteId } from "../domain/rite.ts"
import type { PageId } from "./verses.ts"

export type TeaserScene = {
  readonly rite: RiteId
  readonly riddle: PageId // whose riddle (src/config/verses.ts) sits over the table
  readonly stepMs: number // a breath between moves
}

export type TeaserConfig = {
  readonly path: string // where it is served: the page is <path>.html
  readonly scenes: readonly TeaserScene[]
  readonly riddleFadeMs: number // one riddle fades out before the next
  readonly riddleInMs: number // the riddle shows this long before the first move
  readonly holdMs: number // a won table rests this long
  readonly latticeRiddle: PageId
  readonly latticeStepMs: number // one more rite won on the lattice
  readonly tabletFoldMs: number // a tablet made whole folds before the next rite
  readonly ternion: { readonly riddle: PageId; readonly stepMs: number } // the last rite: the first, one scale up
  readonly monadRiddle: PageId
  readonly monadMs: number
  readonly titleMs: number // the title, before it all begins again
}

export const TEASER = {
  path: "introit",
  scenes: [
    { rite: "000", riddle: "threes", stepMs: 1100 },
    { rite: "+00", riddle: "rest", stepMs: 800 },
    { rite: "00-", riddle: "mirror", stepMs: 800 },
    { rite: "00+", riddle: "tide", stepMs: 800 },
    { rite: "0-0", riddle: "fold-high", stepMs: 450 },
    { rite: "-00", riddle: "cascade", stepMs: 800 },
  ],
  riddleFadeMs: 700,
  riddleInMs: 1600,
  holdMs: 1500,
  latticeRiddle: "lattice",
  latticeStepMs: 160,
  tabletFoldMs: 2200,
  ternion: { riddle: "threes", stepMs: 1100 },
  monadRiddle: "monad",
  monadMs: 4200,
  titleMs: 5000,
} as const satisfies TeaserConfig
